import React from "react";
import PanelGroupController from "../../../components/PanelGroupController";
import {fromJS} from "immutable";
import PropertiesList from "../../../components/panels/PropertiesList";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {Query} from "react-apollo";
import {GET_WAREHOUSE} from "../../../queries/inventory";

const WarehousePanel = (props) => {

  let elements = null;
  if (!props.active) {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    let items = fromJS([
      {prop: "id", label: "Id", type: "string"},
      {prop: "location", label: "Location", type: "string"},
      {prop: "info.system", label: "System", type: "id"},
      {prop: "openingTime", label: "Opens", type: "time"},
      {prop: "closingTime", label: "Closes", type: "time"},
      {prop: "timezone", label: "Timezone", type: "string"},
      {prop: "backupWarehouseId", label: "Backup Warehouse", type: "id"},
      {prop: "reservationStatus", label: "Reservations", type: "string"},
      {prop: "courier_category", label: "Courier", type: "category"},
      {prop: "courierId", label: "Courier", type: "string"},
      {prop: "courierAccountNr", label: "Account Nr.", type: "id"}
    ])
    let contactItems = fromJS([
      {prop: "contact_category", label: "Contact Details", type: "category"},
      {prop: "companyName", label: "Company or Name", type: "string"},
      {prop: "contactName", label: "Contact Name", type: "string"},
      {prop: "contactPhone", label: "Phone", type: "string"},
      {prop: "contactEmail", label: "Email", type: "string"},
    ])
    let addressItems = fromJS([
      {prop: "address_category", label: "Address", type: "category"},
      {prop: "address.addressCountryCode", label: "Country", type: "string"},
      {prop: "address.addressAddressLine1", label: "Address Line 1", type: "string"},
      {prop: "address.addressAddressLine2", label: "Address Line 2", type: "string"},
      {prop: "address.addressCity", label: "City", type: "string"},
      {prop: "address.addressStateProvince", label: "State / Province", type: "string"},
      {prop: "address.addressPostcode", label: "Postcode", type: "string"}
    ])
    let properties = items.concat(contactItems).concat(addressItems);    
    let variables = {warehouseId: props.warehouseId}
    elements = (
      <Query query={GET_WAREHOUSE} variables={variables} skip={!props.active}>
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          let warehouse = fromJS(data.warehouse)
          return <PropertiesList properties={properties} data={warehouse} />
        }}
      </Query>
    )
  }

  return (
    <PanelGroupController title={props.title} expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  )

}

WarehousePanel.defaultProps = {
  active: true,
  title: "Warehouse"
}

export default WarehousePanel;